// This file is auto-generated by scripts/update-version.ts
export const version = '2.0.0';
